import { BellSettings } from "@/components/Elemnt/Bell/BellSettings";
import { useParams } from "react-router";

const DeviceConfigBellPage = () => {
  const { appToken = "" } = useParams();
  return <BellSettings appToken={appToken} />;
};

export default DeviceConfigBellPage;
